<template>
  <div class="content">
    <div class="box">
      <div class="del-block m-t-15">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delNewsModal">
          <i class="fa fa-trash"></i>
        </div>
      </div>
      <div class="box-body full-height mt-30 p-2-12">
        <div class="table-row">
          <div class="table-cell">
            <span class="text-red">＊ </span>標題
          </div>
          <div class="table-from">
            <input class="form-control" placeholder="標題最多100字" v-model="announcement.title" maxlength="100"  type="text">
          </div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            <span class="text-red">＊ </span>內文說明
          </div>
          <div class="table-from">
            <textarea class="form-control" cols="30" rows="10" type="text" placeholder="內文最多500字" maxlength="500" v-model="announcement.content"></textarea>
          </div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            <span class="text-red">＊ </span>發佈時間
          </div>
          <div class="table-from w-100">
            <date-picker
              v-model="formTime.time"
              class="hide-date-icon"
              :show-second="false"
              type="datetime"
              valueType="format"
              format="YYYY-MM-DD HH:mm:ss"
              input-class="form-control"
              :clearable="false"
              :disabled-time="notBeforeNow"
              :disabled-date="notBeforeToday"
            />
          </div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            <span class="text-red">＊ </span>發佈對象
          </div>
          <div class="table-from">
            <select class="form-control" v-model="announcement.role_type">
              <option value="0">不限</option>
              <option value="1">Admin</option>
              <option value="2">Brand</option>
              <option value="3">Store</option>
            </select>
          </div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            <span class="text-red">＊ </span>蓋板開關
          </div>
          <div class="table-from">
            <select class="form-control" v-model="announcement.is_overlay">
              <option value="0">不啟用</option>
              <option value="1">啟用</option>
            </select>
          </div>
        </div>
        <div v-if="$route.name ==='editAnnouncement'" class="table-row">
          <div class="table-cell">
            <span class="text-red">＊ </span>重新發佈
          </div>
          <div class="table-from">
            <select class="form-control" v-model="announcement.republish">
              <option value="0">否</option>
              <option value="1">是</option>
            </select>
          </div>
        </div>
        <div class="text-left mt-64">
          <button class="btn btn-success btn_add" @click='addimg()'>新增圖片</button>
        </div>
        <div v-if="img_view" class="m-t-10 form-control">
          <div v-for="(img, index) in img_list"  :key="index">
            <div v-show = "img.image_name !== 'delete'" class="m-y-20">
              <div class="input-group">
                <span class="input-group-addon input-img-title">
                  圖片 {{index + 1}}
                </span>
                <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
                  <span class="inline-block h-auto m-t-5">
                    <div v-if="!img.image_name" class="text-black" v-text="'沒有圖片'" />
                    <img :src="img.image_name" class="h-auto img-responsive" v-if="img.image_name" data-toggle="modal">
                  </span>
                </div>
                <div class="form-control h-100">
                  <label class="btn-upload btn btn-default" style="margin-top: 25px;" :for="'img-'+index" @click="onFileChangeBtn(index)">
                    選擇圖片
                  </label>
                  <input class="form-control" type="file" style="display: none;" @change="onFileChange" :id="'img-'+index">
                </div>
                <div class="input-group-addon w-100-p text-center bg-white p-0-32">
                  <div class="btn btn-danger" data-toggle="modal" @click="del_img(img_list,index)">
                    <i class="fa fa-trash"></i>
                  </div>
                </div>
              </div>
              <div class="text-right text-15 text-red">圖片大小為 寬不限制x高330  512KB 內</div>
            </div>
          </div>
        </div>
        <div class="text-left mt-64">
          <button class="btn btn-success btn_add" @click='addurl()'>新增連結</button>
        </div>
        <div v-if="url_list && url_list.length > 0" class="m-t-10 form-control">
          <div v-for="(url, index) in url_list" >
              <div class="input-group m-y-20">
                <span class="input-group-addon input-url-title">
                  <span class="text-red">＊ </span>
                  連結 {{index + 1}}
                </span>
                <input class="form-control url-input" v-model='url_list[index]' placeholder="網站連結"  type="text" maxlength="1000">
                <div class="input-group-addon text-center bg-white">
                  <div class="btn btn-danger" @click="del_url(url_list,index)">
                    <i class="fa fa-trash"></i>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="box-footer text-center mt-64">
        <router-link to="/announcement">
        <button class="btn btn-default">
            取消
          </button>
        </router-link>
        <button class="btn btn-success" v-if="$route.name ==='addAnnouncement'" @click="updataAll('add')">
          新增
        </button>
        <button class="btn btn-success" v-else @click="updataAll('up')">
          修改
        </button>
      </div>
    </div>
    <m-modal :option="delDesAlisOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import matcherModal from '@/components/elements/Modal.vue'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'announcementForm',
  components: {
    'm-modal': matcherModal,
    DatePicker
  },
  data () {
    return {
      formTime: {
        time: moment().set('second', 0).format('YYYY-MM-DD HH:mm:ss')
      },
      delDesAlisOption: {
        id: 'delNewsModal',
        title: '確認刪除此公告',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'deleteSingleNews'
          }
        ]
      },
      announcement: {
        title: '',
        content: '',
        announce_time: '',
        role_type: '0',
        is_overlay: '0'
      },
      img_list: [
      ],
      url_list: [
      ],
      img_list_del: [
      ],
      img: {
        width: 0,
        height: 0
      },
      // 紀錄是否有圖片尺寸錯誤
      img_size_error: false,
      onFileChangeCurr: 0
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    img_view () {
    // 判斷陣列是否皆已全部刪除
      if (this.img_list) {
        // 判斷所有陣列都為刪除
        let deleteCount = 0
        this.img_list.forEach(img => {
          if (img.image_name === 'delete') {
            deleteCount = deleteCount + 1
          }
        })
        if (deleteCount === this.img_list.length) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  created () {
    if (this.$route.name === 'editAnnouncement') {
      this.getAnnouncement()
    }
    if (this.$route.name === 'addAnnouncement') {
      this.announcement.announce_time = moment().set('second', 0).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    ...mapActions(['setUnReadNotify']),
    addimg () {
      let img = {
        image_name: ''
      }
      this.img_list.push(img)
    },
    addurl () {
      let url = ''
      this.url_list.push(url)
    },
    getAnnouncement () {
      const url = 'announcement/' + this.$route.params.announcement_id
      this.getDataH('get', url, null, (response) => {
        this.announcement = response.data.announcement
        this.announcement.republish = '0'
        this.formTime.time = this.announcement.announce_time
        this.total = response.data.total
        this.img_list = this.announcement.images
        this.url_list = this.announcement.link
      })
    },
    notBeforeToday (date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeNow (date) {
      return date < new Date(moment().set('second', 0).toString())
    },
    // 驗證欄位是否填寫
    vaildForm () {
      if (this.announcement.title === '') {
        this.$notify({
          title: '無填寫標題',
          text: '無填寫標題!',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        return false
      }
      if (this.announcement.content === '') {
        this.$notify({
          title: '無填寫內文',
          text: '無填寫內文!',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        return false
      }
      if (this.announcement.announce_time === '') {
        this.$notify({
          title: '無填寫發布時間',
          text: '無填寫發布時間!',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        return false
      }
      if (this.img_list && this.img_view) {
        for (let i = 0; i < this.img_list.length; i++) {
          // 檢查上傳處是否有上傳，並略過從後端讀取的資料
          if ((!$('#img-' + i)[0].files[0] || this.img_list[i].image_name === '') && !this.img_list[i].id && this.img_list[i].image_name !== 'delete') {
            this.$notify({
              title: '圖片尚未上傳',
              text: '圖片尚未上傳',
              duration: 3000,
              type: 'danger',
              width: 400
            })
            return false
          }
        }
      }
      if (this.announcement.link && this.announcement.link.length > 0) {
        let urlerror = false
        this.announcement.link.some((element, index) => {
          if (element === '') {
            this.$notify({
              title: '連結有誤',
              text: '連結有誤!',
              duration: 3000,
              type: 'danger',
              width: 400
            })
            urlerror = true
            return true
          } else if (element) {
            var lc = element.toLowerCase()
            var isMatch = lc.substr(0, 8) === 'https://' || lc.substr(0, 7) === 'http://'
            if (!isMatch) {
              this.$notify({
                title: '連結有誤',
                text: '連結有誤!',
                duration: 3000,
                type: 'danger',
                width: 400
              })
              urlerror = true
              return true
            }
          }
        })
        if (urlerror === true) {
          return false
        }
      }
      // 若選擇重新發布，則發布時間不可為過去時間
      const now = moment().set('second', 0).format('YYYY-MM-DD HH:mm:ss')
      if (this.$route.name === 'editAnnouncement' && this.announcement.republish === '1' && moment(this.announcement.announce_time).isBefore(now)) {
        this.$notify({
          title: '請調整發佈時間',
          text: '發佈時間不可是已過去時間',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        return false
      }
      return true
    },
    async updataAll (method) {
      this.img_size_error = false
      let imgEmpty = false
      if (method === 'up') {
        if (!this.vaildForm()) {
          return false
        } else {
          if (this.img_list) {
            this.img_size_error = false
            this.img = {
              width: 0,
              height: 0
            }
            imgEmpty = false
            for (let i = 0; i < this.img_list.length; i++) {
              if (this.img_list[i].image_name === '') {
                this.$notify({
                  title: '圖片尚未上傳',
                  text: '圖片尚未上傳',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                })
                imgEmpty = true
              } else if (this.img_list[i].img_size_error === true && this.img_list[i].image_name !== 'delete') {
                this.img_size_error = true
                this.$notify({
                  title: '提醒',
                  text: '圖片' + (i + 1) + '尺寸為' + this.img_list[i].width + 'x' + this.img_list[i].height + '請上傳 寬不限制x高330 圖片',
                  duration: 3000,
                  type: 'danger',
                  width: 400
                })
                return false
              }
            }
            if (!imgEmpty && !this.img_size_error && this.img_view) {
              for (let i = 0; i < this.img_list.length; i++) {
                if ($('#img-' + i)[0].files[0] && this.img_list[i].image_name !== 'delete') {
                  // 讀取API
                  await this.checkImgSize('up', i)
                }
              }
            }
          }
          if (this.img_list_del && this.img_list_del.length > 0 && !imgEmpty && !this.img_size_error) {
            this.deleteImg()
          }
          if (!this.img_size_error && !imgEmpty && !this.img_size_error) {
            this.updateAnnouncement()
          }
        }
      } else if (method === 'add') {
        if (!this.vaildForm()) {
          return false
        } else {
          this.img_size_error = false
          for (let i = 0; i < this.img_list.length; i++) {
            if (this.img_list[i].img_size_error === true && this.img_list[i].image_name !== 'delete') {
              this.img_size_error = true
              this.$notify({
                title: '提醒',
                text: '圖片' + (i + 1) + '尺寸為' + this.img_list[i].width + 'x' + this.img_list[i].height + '請上傳 寬不限制x高330 圖片',
                duration: 3000,
                type: 'danger',
                width: 400
              })
              return false
            }
          }
          if (this.img_size_error === false) {
            this.addAnnouncement()
          }
        }
      }
    },
    addAnnouncement () {
      if (!this.vaildForm()) {
        return false
      }
      const url = 'announcement/create'
      var data = new FormData()
      data.append('role_type', Number(this.announcement.role_type))
      data.append('is_overlay', Number(this.announcement.is_overlay))
      data.append('title', this.announcement.title)
      data.append('content', this.announcement.content)
      data.append('announce_time', this.announcement.announce_time)
      if (this.url_list && this.url_list.length > 0) {
        this.url_list.forEach((element, index) => {
          data.append('link[]', element)
        })
      }
      if (this.img_list && this.img_list.length > 0) {
        this.img_list.forEach((element, index) => {
          if ($('#img-' + index)[0].files[0] && this.img_list[index].image_name !== 'delete') {
            data.append('image_web_file[]', $('#img-' + index)[0].files[0])
          }
        })
      }
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$parent.announcementInfo('open', true)
          this.$router.push({name: 'announcement'})
        }
      })
    },

    updateAnnouncement () {
      const url = 'announcement/' + this.$route.params.announcement_id
      this.announcement.role_type = Number(this.announcement.role_type)
      this.announcement.is_overlay = Number(this.announcement.is_overlay)
      this.announcement.republish = Number(this.announcement.republish)
      this.getDataH('PUT', url, this.announcement, (response) => {
        if (response.data.status === 200) {
          this.$parent.announcementInfo('open', true)
          this.$router.push({name: 'announcement'})
        }
      })
    },
    trigger (event) {
      const url = 'announcement?announcement_ids=' + this.$route.params.announcement_id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$router.push({name: 'announcement'})
        }
      })
    },
    del_img (list, index) {
      if (list[index].id) {
        this.img_list_del.push(list[index].id)
      }
      // 紀錄為刪除欄位
      list[index].image_name = 'delete'
    },
    del_url (list, index) {
      list.splice(index, 1)
    },
    updatedImg (method, pid) {
      var data = new FormData()
      if (this.img_list[pid] && this.img_list[pid].id) {
        data.append('announcement_image_id', this.img_list[pid].id)
      }
      data.append('image_name', $('#img-' + pid)[0].files[0])
      var url = '/announcement/uploadImage/' + this.$route.params.announcement_id
      return new Promise((resolve, reject) => {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            return resolve()
          }
        })
      })
    },
    deleteImg () {
      var url = '/announcement/deleteImage/' + this.$route.params.announcement_id + '?announcement_image_ids=' + this.img_list_del.toString()
      return new Promise((resolve, reject) => {
        this.getDataH('delete', url, null, function (response) {
          if (response.data.status === 200) {
            return resolve()
          }
        })
      })
    },
    checkImgSize (type, pid) {
      // 沒有id 代表新上傳的圖片
      if (((this.img_list[pid].height !== 330) && this.img_list[pid].width !== 0 && this.img_list[pid].height !== 0)) {
        this.$notify({
          title: '提醒',
          text: '圖片' + (pid + 1) + '尺寸為' + this.img_list[pid].width + 'x' + this.img_list[pid].height + '請上傳 寬不限制x高330 圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        this.img_size_error = true
        this.img_list[pid].img_size_error = true
      } else if (type === 'up') {
        this.updatedImg('up', pid)
      }
    },
    createImage (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        this.img_list[this.onFileChangeCurr].image_name = img.src
        img.onload = () => {
          this.img_list[this.onFileChangeCurr].width = img.width
          this.img_list[this.onFileChangeCurr].height = img.height
          this.checkImgSize(null, this.onFileChangeCurr)
        }
      }
      // :TODO 待確認是否更改
      reader.readAsDataURL(file, this.onFileChangeCurr)
    },
    onFileChange (e = {}) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (imgSize > 512) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於512KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.createImage(files[0])
      }
    },
    onFileChangeBtn (index) {
      this.onFileChangeCurr = index
    }
  },
  watch: {
    'formTime.time' (val) {
      this.announcement.announce_time = val
    }
  }
}
</script>
<style scoped>
.full-height {
  height: fit-content
}
.table-row {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}
.table-footer {
  display: flex;
  justify-content: center;
}
.table-row:first-child{
  margin-top: 30px;
}
.table-row:last-child{
  margin-bottom: 150px;
}
.table-cell{
  color: #FFF;
  background-color: #242D31;
  width: 220px;
  line-height: 34px;
  font-weight: bold;
  padding-left: 15px;
}
.mt-30 {
  margin-top: 30px
}
.p-2-12 {
  padding: 0em 6em
}
.mt-64 {
  margin-top: 4em;
}
.btn_add {
  padding: 12px 56px;
}
.input-img-title {
  padding-right: 156px;
}
.input-url-title {
  padding-right: 132px;
}
.m-y-20 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.p-0-32 {
  padding: 0px 32px;
}
.url-input {
  height: 64px;
}
</style>



// WEBPACK FOOTER //
// AnnouncementForm.vue?63b83a06